export const COLUMN_ID_ATTRIBUTE = 'data-column-id';
